import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { ApplicationFormComponent } from './pages/application-form/application-form.component';
import { RegisterComponent } from './pages/register/register.component';
import { tokenGuard } from 'src/app/core/guard/token.guard';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { routeMetaData } from 'src/app/shared/constants/route-metadata.constant';

const routes: Routes = [
  {
    path: '',
    redirectTo: routeMetaData.login.link.startsWith('/')
      ? routeMetaData.login.link.substring(1)
      : routeMetaData.login.link,
    pathMatch: 'full',
  },
  {
    path: routeMetaData.login.link.startsWith('/')
      ? routeMetaData.login.link.substring(1)
      : routeMetaData.login.link,
    component: LoginComponent,
    data: { title: routeMetaData.login.title },
  },
  {
    path: routeMetaData.applicationForm.link.startsWith('/')
      ? routeMetaData.applicationForm.link.substring(1)
      : routeMetaData.applicationForm.link,
    component: ApplicationFormComponent,
    data: { title: routeMetaData.applicationForm.title },
  },
  {
    path: routeMetaData.forgetPsw.link.startsWith('/')
      ? routeMetaData.forgetPsw.link.substring(1)
      : routeMetaData.forgetPsw.link,
    component: ForgotPasswordComponent,
    data: { title: routeMetaData.forgetPsw.title },
  },
  {
    path: routeMetaData.createAccount.link.startsWith('/')
      ? routeMetaData.createAccount.link.substring(1)
      : routeMetaData.createAccount.link,
    component: RegisterComponent,
    canActivate: [tokenGuard],
    data: { title: routeMetaData.createAccount.title },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
